<template>
    <v-overlay
        :absolute="true"
        v-model="modalActive"
        color="#f3f6f9"
        opacity="0.9"
    >
        <v-container
            fluid
            fill-height
        >
            <v-layout
                justify-center
                align-center
            >
                <v-progress-circular
                    indeterminate
                    color="primary"
                />
            </v-layout>
        </v-container>
    </v-overlay>
</template>

<script>
import { mapState } from 'vuex';

export default {
    computed: {
        ...mapState('overlay', ['modalActive'])
    },
};
</script>
